import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '../services/auth/auth.service';

/**
 * HTTP interceptor that handles authentication errors.
 * Automatically logs out the user on 401 (Unauthorized) responses.
 */
export const authErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);

  return next(req).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse && error.status === 401) {
        // Don't logout if the error is from auth endpoints (login, refresh, etc.)
        const isAuthEndpoint = req.url.includes('/auth/');

        if (!isAuthEndpoint) {
          // Trigger logout without waiting for it to complete
          authService.logout().subscribe();
        }
      }

      return throwError(() => error);
    }),
  );
};
